import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { SORT_OPTIONS, getSortOptionsArray } from '../../search/searchSort/SortOptions';
import './BrandFilterToolbar.css';

const BRAND_SORT_CODES = [
    SORT_OPTIONS.POPULAR.code,
    SORT_OPTIONS.NEW.code,
    SORT_OPTIONS.LIKE.code,
    SORT_OPTIONS.DISCOUNT.code,
    SORT_OPTIONS.LOW_PRICE.code,
    SORT_OPTIONS.HIGH_PRICE.code,
];

/**
 * 브랜드 페이지 필터 툴바
 * 상품 수 + 모바일 필터 버튼 + 정렬 셀렉트
 */
export default function BrandFilterToolbar({ productCount, selectedSort, onSortChange, onFilterOpen, stickyOffset, toolbarRef }) {
    const sortOptions = useMemo(
        () => getSortOptionsArray().filter((opt) => BRAND_SORT_CODES.includes(opt.code)),
        []
    );
    const normalizedSelectedSort = BRAND_SORT_CODES.includes(selectedSort)
        ? selectedSort
        : SORT_OPTIONS.POPULAR.code;

    useEffect(() => {
        if (selectedSort !== normalizedSelectedSort) {
            onSortChange(normalizedSelectedSort);
        }
    }, [selectedSort, normalizedSelectedSort, onSortChange]);

    return (
        <div
            className="BrandFilterToolbar"
            ref={toolbarRef}
            style={stickyOffset ? {'--brand-toolbar-sticky-top': `${stickyOffset}px`} : undefined}
        >
            <div className="BrandFilterToolbar-inner">
                <div className="BrandFilterToolbar-count">
                    <strong>{(productCount || 0).toLocaleString()}</strong> listings
                </div>
                <button
                    className="BrandFilterToolbar-filter-btn"
                    onClick={onFilterOpen}
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
                    </svg>
                    필터
                </button>
                <div className="BrandFilterToolbar-right">
                    <div className="BrandFilterToolbar-sort">
                        <span className="BrandFilterToolbar-sort-label">Sort by</span>
                        <select
                            className="BrandFilterToolbar-sort-select"
                            value={normalizedSelectedSort}
                            onChange={(e) => onSortChange(e.target.value)}
                        >
                            {sortOptions.map((opt) => (
                                <option key={opt.code} value={opt.code}>
                                    {opt.title}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
}

BrandFilterToolbar.propTypes = {
    productCount: PropTypes.number,
    selectedSort: PropTypes.string.isRequired,
    onSortChange: PropTypes.func.isRequired,
    onFilterOpen: PropTypes.func.isRequired,
    stickyOffset: PropTypes.number,
    toolbarRef: PropTypes.object,
};
